"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetChartData = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = require("react");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _actions = require("../redux/actions");
var _selectors = require("../redux/selectors");
var _function = require("../utils/function");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  getTo14Day,
  isEmpty
} = _paulCorePackage.functions;
const useGetChartData = _ref => {
  let {
    chartId,
    devicesForChartRequest
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const token = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getToken);
  const {
    from,
    to,
    rangeType,
    isPrediction
  } = (0, _reactRedux.useSelector)((0, _selectors.selectChartParams)(chartId), (prev, next) => {
    const {
      from: pFrom,
      to: pTo,
      rangeType: pRangeType,
      isPrediction: pIsPrediction
    } = prev;
    const {
      from: nFrom,
      to: nTo,
      rangeType: nRangeType,
      isPrediction: nIsPrediction
    } = next;
    return (0, _moment.default)(pFrom).isSame(nFrom) && (0, _moment.default)(pTo).isSame(nTo) && pRangeType === nRangeType && pIsPrediction === nIsPrediction;
  });
  (0, _react.useEffect)(() => {
    if (token && !isEmpty(devicesForChartRequest)) {
      const fromWithCompensation = from ? (0, _function.toCompensateForStartOfDay)({
        rangeType,
        date: from
      }) : null;
      const makeRequestFormatData = date => (0, _moment.default)(date).utc().unix();
      const params = {
        entities: devicesForChartRequest || {},
        from: fromWithCompensation ? makeRequestFormatData(fromWithCompensation) : null,
        to: makeRequestFormatData(isPrediction ? getTo14Day(to) : to),
        type: rangeType,
        predictions: false,
        timezone: new Date().getTimezoneOffset()
      };
      dispatch((0, _actions.setChartParamsList)({
        chartId,
        params: {
          inProgress: true
        }
      }));
      dispatch((0, _actions.getChartDataAction)(_objectSpread(_objectSpread({}, params), {}, {
        chartId
      })));
    }
  }, [token, dispatch, devicesForChartRequest, chartId, from, to, rangeType, isPrediction]);
};
exports.useGetChartData = useGetChartData;
useGetChartData.propTypes = {
  chartId: _propTypes.default.string,
  devicesForChartRequest: _propTypes.default.shape({})
};